import { notice } from "JS/utils/notice";

export default class AddFavoriteProduct {

    userAuth = false;

    constructor(favBtn) {
        if (!favBtn) {
            return;
        }
        this.favBtn = favBtn
        this.productId = this.favBtn.dataset.productId;
        this.userAuth = this.favBtn.getAttribute('data-open-auth') ? true : false;
        this.init();
    }

    init() {
        this.addListeners();

        if (localStorage.getItem('authFav') === 'auth') {
            localStorage.removeItem('authFav');
            this.sendFormData();
        }
    }

    addListeners() {
        this.favBtn.addEventListener('click', () => {
            if (this.userAuth) {
                return;
            }
            
            this.sendFormData();
        });
    }

    toggleActiveBtn(status) {
        if (!status) return;

        if (status && this.favBtn.classList.contains('active')) {
            this.favBtn.classList.remove('active');
        } else if (status && !this.favBtn.classList.contains('active')) {
            this.favBtn.classList.add('active');
        }
    }

    showNotice(status, data) {
        if (status && data.added) {
            notice('Товар добавлен в избранное', 'success');
        } else if (status && data.removed) {
            notice('Товар удален из избранного', 'warning');
        } else {
            notice(data.message, 'error');
        }
    }

    sendFormData() {
        const prepareData = {
            action: 'hml_favorite_product',
            product_id: this.productId,
            nonce: backendData.favorite_nonce,
            operation: this.favBtn.classList.contains('active') ? 'del' : 'set',
        }

        const formData = new FormData();

        Object.keys(prepareData).forEach(key => {
            formData.append(key, prepareData[key]);
        });

        this.favBtn.classList.add('processing');

        fetch(backendData.ajaxUrl, {
            method: "POST",
            body: formData,
        }).then(res => {
            return res.json();
        }).then(res => {
            const { data, success } = res;

            this.toggleActiveBtn(success);

            this.showNotice(success, data);
        })
        .catch((error) => {
            notice(error.message, 'error');
        })
        .finally(() => {
            this.favBtn.classList.remove('processing');
        });
    }
}
